import { z } from 'zod';

/**
 * `YYYY-MM-DD`, the only date shape that crosses the wire.
 *
 * One declaration. It was four inside this package — three copies of the same schema
 * and a fourth spelling of the regex inline — so a guard that is supposed to be the
 * single answer to "what is a date here" had four places to disagree.
 */
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
